import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MatInputModule} from '@angular/material/input';
import {FormModule} from '../../../form/form.module';
import {ReactiveFormsModule} from '@angular/forms';
import {InputTextComponent} from './input-text.component';
import {MatDatepickerModule} from "@angular/material/datepicker";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        MatInputModule,
        MatDatepickerModule,
    ],
    declarations: [
        InputTextComponent,
    ],
    exports: [
        InputTextComponent,
    ],
})
export class InputTextModule {
}
